<template>
  <td class="text-xs-right">{{ $n(value, format) }}</td>
</template>

<script>
export default {
  props: ['value', 'format']
}
</script>
